module.exports = __webpack_public_path__ + "static/img/bigErweima.794bde75.png";